<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<money
			:value="value"
			:placeholder="placeholder"
			:disabled="disabled"
			@input="(value) => $emit('input', value)"
			@change="(value) => $emit('change', value)"
			v-bind="_vpercem(casas)"
			class="form-control input-sm"
			:class="{'text-right' : alinharEsquerda}"
		></money>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		placeholder: {
			type: String,
			required: false,
			default: ''
		},

		value: {
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		casas: {
			type: Number,
			default: 2
		},

		alinharEsquerda: {
			type: Boolean,
			default: true
		}
	}
}
</script>